import React from 'react';

interface Props
{
  type: string,
}

export const Card: React.FC<Props> = ({type, children}) => <article className={['card', type].join(' ')}>{children}</article>;